import React, { useMemo } from "react"

import { useMachine, useRestoredUniverse } from "@lib"
import { OMReference } from "@apptivity-lab/firmament-node-sdk"

import { CnxMeeting } from "@firmament-packages/connectx"

import AffExpertProfile from "../AffExpertProfile"
import AffRatingCell from "./AffRatingCell"
import { AffRatingListStateMachine } from "@machines/AffRatingListStateMachine"

import LoadingIndicator from "@components/LoadingIndicator"

const AffRatingList: React.FunctionComponent<{
    subject: CnxMeeting,
    containerRef: React.RefObject<HTMLDivElement>
}> = ({
    subject,
    containerRef
}) => {
    const [machine, machineState] = useMachine(AffRatingListStateMachine)

    useRestoredUniverse(useMemo(() => () => {
        if (subject.meetingTemplate) {
            machine.refresh({ meetingTemplateId: subject.meetingTemplate })
        } else if (subject.provider) {
            machine.refresh({ expertProfileId: new OMReference(AffExpertProfile, subject.provider.id) })
        }
    }, [machine, subject]))

    switch (machineState.name) {
        case "loading":
            return (<LoadingIndicator />)
        case "presenting":
            return (
                <div ref={containerRef} className="p-[8px] flex flex-nowrap overflow-auto snap-x gap-x-[20px]">
                    {machineState.ratings.map((rating, index) => {
                        return <AffRatingCell key={rating.id} variant="MEDIUM_LIST" rating={rating} />
                    })}
                </div>
            )
        case "showingError":
            return null
        default:
            return null
    }
}

export default AffRatingList
